export default __webpack_public_path__ + "static/media/logo.192fd526.svg";